"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _scroll_ended = _interopRequireDefault(require("../utils/scroll_ended"));

require("../../css/shared/app_bar_panel.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AppBarPanel =
/*#__PURE__*/
function (_Component) {
  _inherits(AppBarPanel, _Component);

  function AppBarPanel(props) {
    var _this;

    _classCallCheck(this, AppBarPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppBarPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function (element) {
      var _this$props = _this.props,
          onScrollEnd = _this$props.onScrollEnd,
          scrollEndOffset = _this$props.scrollEndOffset;

      if (onScrollEnd && (0, _scroll_ended.default)(element.target, scrollEndOffset)) {
        onScrollEnd();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closeIfOpen", function () {
      var onToggleClick = _this.props.onToggleClick;
      var open = _this.state.open;

      if (!open) {
        return;
      }

      _this.setState({
        open: false
      }, onToggleClick(open));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleButtonClick", function () {
      var onToggleClick = _this.props.onToggleClick;

      _this.setState(function (state) {
        return {
          open: !state.open
        };
      }, onToggleClick(_this.state.open));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleWindowMouseDown", function (event) {
      if (_this.node && _this.node.contains(event.target)) return;

      _this.closeIfOpen();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleWindowKeyUp", function (event) {
      if (event.key === 'Escape') {
        _this.closeIfOpen();
      }
    });

    _this.node = null;
    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(AppBarPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('mousedown', this.handleWindowMouseDown);
      window.addEventListener('keyup', this.handleWindowKeyUp);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.handleWindowMouseDown);
      window.removeEventListener('keyup', this.handleWindowKeyUp);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          footer = _this$props2.footer,
          panelClassName = _this$props2.panelClassName,
          title = _this$props2.title,
          toggle = _this$props2.toggle;
      var open = this.state.open;
      var wrapperClasses = (0, _classnames2.default)({
        'vn-app-bar-panel__wrapper': true,
        'vn-app-bar-panel__wrapper--visible': open === true
      });
      var panelClasses = (0, _classnames2.default)(_defineProperty({}, panelClassName, panelClassName !== null));
      return _react.default.createElement("div", {
        className: "vn-app-bar-panel",
        ref: function ref(node) {
          _this2.node = node;
        }
      }, _react.default.createElement("div", {
        className: wrapperClasses
      }, _react.default.createElement("div", {
        className: "vn-app-bar-panel__header"
      }, _react.default.createElement("div", {
        className: "vn-app-bar-panel__title"
      }, title), toggle(this.handleButtonClick, open)), _react.default.createElement("div", {
        className: "vn-app-bar-panel__container"
      }, _react.default.createElement("div", {
        className: panelClasses,
        onScroll: function onScroll(e) {
          return _this2.onScroll(e);
        }
      }, children)), footer && _react.default.createElement("div", {
        className: "vn-app-bar-panel__footer"
      }, footer)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      var show = props.show;

      if (show !== undefined) {
        return {
          open: show
        };
      }

      return null;
    }
  }]);

  return AppBarPanel;
}(_react.Component);

AppBarPanel.propTypes = {
  children: _propTypes.default.node,
  footer: _propTypes.default.node,
  // eslint-disable-next-line react/no-unused-prop-types
  show: _propTypes.default.bool,
  onScrollEnd: _propTypes.default.func,
  onToggleClick: _propTypes.default.func,
  panelClassName: _propTypes.default.string,
  scrollEndOffset: _propTypes.default.number,
  title: _propTypes.default.string,
  toggle: _propTypes.default.func
};
AppBarPanel.defaultProps = {
  children: null,
  footer: undefined,
  show: undefined,
  onScrollEnd: undefined,
  onToggleClick: function onToggleClick() {},
  panelClassName: null,
  scrollEndOffset: 0,
  title: '',
  toggle: function toggle(onClick) {
    return _react.default.createElement("button", {
      onClick: onClick,
      type: "button"
    });
  }
};
AppBarPanel.displayName = 'AppBarPanel';
var _default = AppBarPanel;
exports.default = _default;